export default "__VITE_ASSET__CSYpCtJl__"